import type { HTMLAttributes, ReactNode, TableHTMLAttributes, TdHTMLAttributes } from 'react';

/**
 * Tabla de datos con su propio scroll horizontal: la página nunca scrollea en horizontal (regla del
 * propietario, `docs/02-ux.md` §5), así que el desborde se queda dentro de la tabla.
 */
export function TablaAncha({
  children,
  className = '',
  claseCaja = '',
  e2eCaja,
  ...props
}: {
  children: ReactNode;
  className?: string;
  /** Clases de la caja que desplaza: con un alto máximo, la tabla baja dentro de ella y un encabezado fijo se queda arriba. */
  claseCaja?: string;
  e2eCaja?: string;
} & TableHTMLAttributes<HTMLTableElement>) {
  return (
    <div className={`overflow-x-auto ${claseCaja}`} data-e2e={e2eCaja}>
      <table className={`w-full text-left ${className}`} {...props}>
        {children}
      </table>
    </div>
  );
}

/** La fila de títulos de cualquier tabla del producto. */
/** Con `fijo`, los nombres de columna se quedan arriba cuando la tabla se desplaza dentro de su caja. */
export function EncabezadoTabla({ children, fijo = false }: { children: ReactNode; fijo?: boolean }) {
  return (
    <thead className={fijo ? 'bg-card sticky top-0 z-10' : undefined}>
      <tr className="text-muted border-border border-b text-etiqueta uppercase tracking-wide">{children}</tr>
    </thead>
  );
}

/** Fila de datos: separador abajo salvo en la última. */
export function FilaTabla({
  children,
  className = '',
  ...props
}: { children: ReactNode } & HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr className={`border-border border-b last:border-0 ${className}`} {...props}>
      {children}
    </tr>
  );
}

/**
 * Celda de dinero o de cantidad: a la derecha y con tipografía tabular, para que las columnas de
 * plata se puedan comparar de un vistazo.
 */
export function CeldaPlata({
  children,
  fuerte = false,
  className = '',
  ...props
}: { children: ReactNode; fuerte?: boolean } & TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={`num py-2 pr-2 text-right ${fuerte ? 'font-bold' : ''} ${className}`} {...props}>
      {children}
    </td>
  );
}

/**
 * Cabecera de la columna de acciones de una tabla: sin ella la columna parece no existir.
 */
export function ThAcciones({ className = '' }: { className?: string }) {
  return (
    <th className={`text-muted py-2 text-right text-etiqueta font-bold uppercase tracking-wide ${className}`}>
      Acciones
    </th>
  );
}
